import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section"]

  update(event) {
    this.sectionTargets.forEach(section => {
      section.classList.toggle("hidden", !event.target.checked)
    })
  }
}
